import _ from 'lodash';
import update from 'react/lib/update';

import {
	SET_PAGE,
	CLEAR_FILTER, ADD_FILTER, REMOVE_FILTER, TOGGLE_FILTER,
	SET_FILTER_TEXT, SET_FILTER
} from '../actions/filter';

const initialState = {
	page: 1,
	text: ''
};

function filter(state = initialState, action){
	switch(action.type){
		case SET_PAGE:
			return update(state, {
				page: { $set: action.page }
			});

		case CLEAR_FILTER:
			return initialState;

		case ADD_FILTER:
			return update(state, {[action.name]: {$apply: values => {
				return _(values).push(action.value).uniq().value();
			}}});

		case REMOVE_FILTER:
			return update(state, {[action.name]: {$apply: values => {
				return _(values).filter(v => v !== action.value).value()
			}}});

		case TOGGLE_FILTER:
			let ret;
			if(!state[action.name]){
				ret = update(state, {[action.name]: {$set: [action.value]}});
			} else {
				if(_(state[action.name]).includes(action.value)){
					ret = update(state, {[action.name]: {$apply: values => {
						return _(values).filter(v => v !== action.value).value()
					}}});
				} else {
					ret = update(state, {[action.name]: {$apply: values => {
						return _(values).push(action.value).uniq().value();
					}}});
				}
			}

			return update(ret, {page: {$set: 1}});

		case SET_FILTER_TEXT:
			return update(state, { text: {$set: action.text }, page: {$set: 1}});

		case SET_FILTER:
			return action.filter;

		default:
			return state;
	}
}

export default filter;
